import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { useAuth } from "../../contexts/AuthContext";

const RoleSwitcher = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { userRoles, activeRole, switchRole, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine the displayed role based on the current URL path
  const currentPath = location.pathname;
  const displayedRole = currentPath.startsWith('/brand') ? 'brand' : 
                       currentPath.startsWith('/influencer') ? 'influencer' : 
                       activeRole;
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleRoleSwitch = async (role) => {
    handleClose();
    
    if (role === displayedRole) return;
    
    const success = await switchRole(role);
    
    if (success) {
      navigate(`/${role}`);
    }
  };
  
  // Don't render if user has only one role
  if (!userRoles || userRoles.length <= 1) {
    return null;
  }
  
  const roleDisplay = (role) => {
    return role.charAt(0).toUpperCase() + role.slice(1);
  };
  
  return (
    <>
      <Button 
        color="inherit" 
        onClick={handleClick}
        disabled={loading}
        sx={{ textTransform: 'none', ml: 2 }}
      >
        <Typography variant="body1">
          {displayedRole ? `${roleDisplay(displayedRole)} ▼` : 'Switch Role ▼'}
        </Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {userRoles.map((role) => (
          <MenuItem 
            key={role} 
            onClick={() => handleRoleSwitch(role)}
            selected={role === displayedRole}
          >
            {roleDisplay(role)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default RoleSwitcher;
